import { Constants } from "../functions/constants";

const popupMixin = {
    methods: {
        liftPopupSection: function (val) {
            var popup = this.$refs["popup"];
            if (popup) {
                var section = popup.closest('body>section');
            }
            if (section)
                section.classList.toggle(Constants.CLASS_NAMES.BODY_MENUS_OPENED_CLASS, val)
        }
    }
};

export default popupMixin;